(function () {
  'use strict';

  var modal    = document.getElementById('sfm');
  if (!modal) return;

  var backdrop  = modal.querySelector('.sfm__backdrop');
  var closeBtn  = modal.querySelector('.sfm__close');
  var tabs      = Array.prototype.slice.call(modal.querySelectorAll('.sfm__tab'));
  var panes     = Array.prototype.slice.call(modal.querySelectorAll('.sfm__pane'));
  var tabsWrap  = modal.querySelector('.sfm__tabs');

  var defaultTab = modal.getAttribute('data-sfm-default') || 'faqs';
  var activeTab  = defaultTab;

  var paneMap = {};
  panes.forEach(function (p) {
    var name = p.getAttribute('data-sfm-pane');
    paneMap[name] = p;
    if (p.classList.contains('sfm__pane--active')) activeTab = name;
  });

  /* ── Sliding pill ── */
  var sliderEl = null;
  if (tabsWrap && tabs.length > 1) {
    sliderEl = document.createElement('span');
    sliderEl.className = 'sfm__tab-slider';
    tabsWrap.insertBefore(sliderEl, tabsWrap.firstChild);
    tabsWrap.classList.add('has-slider');
    modal.classList.add('is-visible');
    requestAnimationFrame(function () {
      positionSlider(activeTab, false);
      modal.classList.remove('is-visible');
    });
  }

  function positionSlider(tabName, animate) {
    if (!sliderEl || !tabsWrap) return;
    var tabEl = tabsWrap.querySelector('[data-sfm-tab="' + tabName + '"]');
    if (!tabEl) return;
    if (!animate) sliderEl.style.transition = 'none';
    sliderEl.style.width  = tabEl.offsetWidth  + 'px';
    sliderEl.style.height = tabEl.offsetHeight + 'px';
    sliderEl.style.left   = tabEl.offsetLeft   + 'px';
    sliderEl.style.top    = tabEl.offsetTop    + 'px';
    if (!animate) requestAnimationFrame(function () { sliderEl.style.transition = ''; });
  }

  function setTabButtons(tabName) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-sfm-tab') === tabName;
      t.classList.toggle('sfm__tab--active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function setTabInstant(tabName) {
    if (!paneMap[tabName]) return;
    activeTab = tabName;
    setTabButtons(tabName);
    panes.forEach(function (p) {
      p.classList.toggle('sfm__pane--active', p.getAttribute('data-sfm-pane') === tabName);
    });
    positionSlider(tabName, false);
    updateFooterState(tabName);
  }

  function switchTab(newTabName) {
    if (newTabName === activeTab || !paneMap[newTabName]) return;
    if (paneMap[activeTab]) paneMap[activeTab].classList.remove('sfm__pane--active');
    paneMap[newTabName].classList.add('sfm__pane--active');
    activeTab = newTabName;
    setTabButtons(newTabName);
    positionSlider(newTabName, true);
    updateFooterState(newTabName);
  }

  /* ── Footer state ── */
  function updateFooterState(tabName) {
    modal.classList.toggle('sfm--contact-active', tabName === 'contact');
  }

  /* ── Open / close ── */
  function openModal(tabName) {
    modal.classList.add('is-visible');
    requestAnimationFrame(function () {
      if (sliderEl) positionSlider(activeTab, false);
      if (tabName && tabName !== activeTab) setTabInstant(tabName);
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  function closeModal() {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!modal.classList.contains('is-open')) {
        modal.classList.remove('is-visible');
        resetContactForm();
      }
    }, 350);
  }

  /* ── Contact form ── */
  var contactPane  = paneMap['contact'];
  var contactForm  = contactPane && contactPane.querySelector('.sfm__contact-form');
  var contactWrap  = contactPane && contactPane.querySelector('.sfm__contact-form-wrap');
  var successEl    = contactPane && contactPane.querySelector('.sfm__contact-success');
  var sendBtn      = modal.querySelector('[data-sfm-send]');
  var closeDoneBtn = modal.querySelector('[data-sfm-close-done]');
  var sendLabelEl  = sendBtn && sendBtn.querySelector('.sfm__send-label');
  var sendLabelTxt = sendLabelEl ? sendLabelEl.textContent.trim() : (sendBtn ? sendBtn.textContent.trim() : 'Send message');

  /* ── Hidden iframe for native form submit — avoids Shopify CSRF quirks with fetch() ── */
  var sfmIframeName = 'sfm-post-frame';
  var sfmIframe = (function () {
    var ex = document.getElementById('sfm-post-frame');
    if (ex) return ex;
    var f = document.createElement('iframe');
    f.id = 'sfm-post-frame';
    f.name = 'sfm-post-frame';
    f.setAttribute('aria-hidden', 'true');
    f.style.cssText = 'position:fixed;width:1px;height:1px;top:-9999px;left:-9999px;border:0';
    document.body.appendChild(f);
    return f;
  })();

  /* Example message cycling */
  var textareaWrap  = contactPane && contactPane.querySelector('.sfm__contact-textarea-wrap');
  var bodyTextarea  = contactForm  && contactForm.querySelector('[name="contact[body]"]');
  var exampleEls    = textareaWrap ? Array.prototype.slice.call(textareaWrap.querySelectorAll('.sfm__contact-example')) : [];
  var exIdx = 0, exTimer = null;

  function cycleExample() {
    exampleEls[exIdx].classList.remove('is-active');
    exIdx = (exIdx + 1) % exampleEls.length;
    exampleEls[exIdx].classList.add('is-active');
  }
  function startExamples() { if (exampleEls.length < 2 || exTimer) return; exTimer = setInterval(cycleExample, 3500); }
  function stopExamples()  { clearInterval(exTimer); exTimer = null; }

  if (bodyTextarea && exampleEls.length > 0) {
    bodyTextarea.addEventListener('focus', function () {
      stopExamples();
      if (textareaWrap) textareaWrap.classList.add('has-focus');
    });
    bodyTextarea.addEventListener('blur', function () {
      if (textareaWrap) textareaWrap.classList.remove('has-focus');
      if (!bodyTextarea.value.trim()) startExamples();
    });
    bodyTextarea.addEventListener('input', function () {
      if (textareaWrap) textareaWrap.classList.toggle('has-content', bodyTextarea.value.length > 0);
    });
    startExamples();
  }

  function isValidEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim()); }

  function setFieldError(attr, hasError) {
    var field = contactForm && contactForm.querySelector('[data-sfm-field="' + attr + '"]');
    if (!field) return;
    field.classList.toggle('has-error', hasError);
    var inp = field.querySelector('.sfm__contact-input, .sfm__contact-textarea');
    if (inp) inp.classList.toggle('is-error', hasError);
  }

  function validateContact() {
    if (!contactForm) return false;
    var nameInp  = contactForm.querySelector('[name="contact[name]"]');
    var emailInp = contactForm.querySelector('[name="contact[email]"]');
    var bodyInp  = contactForm.querySelector('[name="contact[body]"]');
    var nameOk  = nameInp  && nameInp.value.trim().length > 0;
    var emailOk = emailInp && isValidEmail(emailInp.value);
    var bodyOk  = bodyInp  && bodyInp.value.trim().length > 0;
    setFieldError('name',  !nameOk);
    setFieldError('email', !emailOk);
    setFieldError('body',  !bodyOk);
    return nameOk && emailOk && bodyOk;
  }

  function sendContact() {
    if (!validateContact()) return;
    if (sendBtn && sendBtn.classList.contains('is-sending')) return;
    if (sendBtn) sendBtn.classList.add('is-sending');
    if (sendLabelEl) sendLabelEl.textContent = 'Sending…';
    else if (sendBtn) sendBtn.textContent = 'Sending…';

    var done = false;

    function onSuccess() {
      if (done) return;
      done = true;
      clearTimeout(errorTimer);
      sfmIframe.onload = null;
      contactForm.removeAttribute('target');
      if (sendBtn) {
        sendBtn.classList.remove('is-sending');
        if (sendLabelEl) sendLabelEl.textContent = sendLabelTxt;
        else sendBtn.textContent = sendLabelTxt;
        sendBtn.classList.add('is-flying');
      }
      setTimeout(function () {
        if (sendBtn) sendBtn.classList.remove('is-flying');
        modal.classList.add('sfm--contact-success');
        if (contactWrap) contactWrap.style.display = 'none';
        if (successEl) successEl.classList.add('is-visible');
        if (closeDoneBtn) setTimeout(function () { closeDoneBtn.focus(); }, 50);
      }, 750);
    }

    function sfmShowSendError() {
      if (done) return;
      done = true;
      clearTimeout(errorTimer);
      sfmIframe.onload = null;
      contactForm.removeAttribute('target');
      if (!sendBtn) return;
      sendBtn.classList.remove('is-sending');
      sendBtn.classList.add('is-error');
      if (sendLabelEl) sendLabelEl.textContent = 'Something went wrong';
      else sendBtn.textContent = 'Something went wrong';
      setTimeout(function () {
        sendBtn.classList.remove('is-error');
        if (sendLabelEl) sendLabelEl.textContent = sendLabelTxt;
        else sendBtn.textContent = sendLabelTxt;
      }, 3000);
    }

    var errorTimer = setTimeout(sfmShowSendError, 12000);

    sfmIframe.onload = function () {
      var posted = false;
      try { posted = sfmIframe.contentWindow.location.search.indexOf('posted_successfully') !== -1; } catch (e) { posted = true; }
      if (posted) { onSuccess(); } else { sfmShowSendError(); }
    };

    contactForm.setAttribute('target', sfmIframeName);
    contactForm.submit();
  }

  function resetContactForm() {
    modal.classList.remove('sfm--contact-success');
    if (contactWrap) contactWrap.style.display = '';
    if (successEl) successEl.classList.remove('is-visible');
    if (sendBtn) {
      sendBtn.classList.remove('is-sending', 'is-flying');
      if (sendLabelEl) sendLabelEl.textContent = sendLabelTxt;
      else sendBtn.textContent = sendLabelTxt;
    }
    stopExamples();
    if (exampleEls.length > 0) {
      exampleEls.forEach(function (el) { el.classList.remove('is-active'); });
      exIdx = 0;
      exampleEls[0].classList.add('is-active');
    }
    if (textareaWrap) textareaWrap.classList.remove('has-focus', 'has-content');
    if (contactForm) {
      contactForm.reset();
      contactForm.querySelectorAll('.has-error').forEach(function (f) { f.classList.remove('has-error'); });
      contactForm.querySelectorAll('.is-error').forEach(function (i) { i.classList.remove('is-error'); });
    }
    startExamples();
    updateFooterState(activeTab);
  }

  if (contactForm) {
    contactForm.addEventListener('input', function (e) {
      var field = e.target.closest('[data-sfm-field]');
      if (field && field.classList.contains('has-error')) {
        field.classList.remove('has-error');
        e.target.classList.remove('is-error');
      }
    });
  }

  /* ── Event listeners ── */
  if (backdrop)    backdrop.addEventListener('click', closeModal);
  if (closeBtn)    closeBtn.addEventListener('click', closeModal);
  if (sendBtn)     sendBtn.addEventListener('click', sendContact);
  if (closeDoneBtn) closeDoneBtn.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && modal.classList.contains('is-open')) closeModal();
  });

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () { switchTab(tab.getAttribute('data-sfm-tab')); });
  });

  function tabFromTrigger(el) {
    if (el.hasAttribute('data-open-sfm')) {
      var v = el.getAttribute('data-open-sfm');
      return (v === 'faqs' || v === 'contact') ? v : defaultTab;
    }
    var href = el.getAttribute('href') || '';
    if (href === '#open-sfm-faqs')    return 'faqs';
    if (href === '#open-sfm-contact') return 'contact';
    return defaultTab;
  }

  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== document) {
      var href = el.getAttribute('href') || '';
      if (
        el.hasAttribute('data-open-sfm') ||
        href === '#open-sfm' ||
        href === '#open-sfm-faqs' ||
        href === '#open-sfm-contact'
      ) {
        e.preventDefault();
        openModal(tabFromTrigger(el));
        return;
      }
      el = el.parentElement;
    }
  });

  /* FAQ accordion (single open) */
  Array.prototype.slice.call(modal.querySelectorAll('.sfm__faq-q')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card    = btn.closest('.sfm__faq');
      var wasOpen = card && card.classList.contains('is-open');
      Array.prototype.slice.call(modal.querySelectorAll('.sfm__faq.is-open')).forEach(function (c) {
        c.classList.remove('is-open');
        var q = c.querySelector('.sfm__faq-q');
        if (q) q.setAttribute('aria-expanded', 'false');
      });
      if (card && !wasOpen) {
        card.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  updateFooterState(activeTab);

  /* ── Float button: stay above fixed cookie banners ── */
  var floatBtn = document.querySelector('.sfm-float');
  if (floatBtn) {
    var cookieSelectors = [
      /* Shopify Privacy App */
      '#shopify-pc-banner', '.shopify-privacy-bar',
      /* Common third-party banners */
      '#cookie-banner', '.cc-window', '.cc-floating',
      '[id*="cookie-bar"]', '[class*="cookie-bar"]',
      '[id*="consent"]', '.cookie-notice', '#onetrust-banner-sdk'
    ];
    function adjustFloatBottom() {
      var maxH = 0;
      cookieSelectors.forEach(function (sel) {
        try {
          var els = document.querySelectorAll(sel);
          els.forEach(function (el) {
            /* offsetParent is null for position:fixed — use getComputedStyle */
            var cs = window.getComputedStyle(el);
            if (cs.display === 'none' || cs.visibility === 'hidden') return;
            var rect = el.getBoundingClientRect();
            /* Accept any matching element whose bottom is in the lower half of the screen
               (threshold was window.innerHeight-4 which misses banners with a bottom gap) */
            if (rect.height > 0 && rect.bottom > window.innerHeight * 0.5) {
              /* Offset = height of banner + its gap from the viewport bottom */
              maxH = Math.max(maxH, rect.height + (window.innerHeight - rect.bottom));
            }
          });
        } catch (e) {}
      });
      floatBtn.style.setProperty('--sfm-float-offset', maxH > 0 ? Math.max(0, maxH - 16) + 'px' : '0px');
    }
    adjustFloatBottom();
    /* Re-run at load and after delays to catch banners that inject or animate in late */
    window.addEventListener('load', function () {
      adjustFloatBottom();
      setTimeout(adjustFloatBottom, 600);
      setTimeout(adjustFloatBottom, 2500);
      setTimeout(adjustFloatBottom, 5000);
    });
    /* Watch for banner elements added or shown/hidden anywhere in the DOM */
    var moTimer = null;
    var mo = new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(adjustFloatBottom, 80);
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    window.addEventListener('resize', adjustFloatBottom);
  }

})();
